import BaseEnumType from "../../common/base-enum-type";

const PassResultType = Object.freeze({
    BROKEN_UP: new BaseEnumType("B", "BROKEN_UP"),
    COMPLETE: new BaseEnumType("C", "COMPLETE"),
    DROPPED: new BaseEnumType("D", "DROPPED"),
    FUMBLED: new BaseEnumType("F", "FUMBLED"),
    INCOMPLETE: new BaseEnumType("I", "INCOMPLETE"),
    INTERCEPTED: new BaseEnumType("X", "INTERCEPTED"),
    OTHER: new BaseEnumType("", "OTHER"),
    SACKED: new BaseEnumType("S", "SACKED")
});

export default PassResultType;
